import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding } from "@angular/core";

import { SpsGrowlerService, GrowlerConfig } from "../../services/sps-growler.service";

@Component({
    selector: "sps-growler-outlet",
    templateUrl: "./sps-growler-outlet.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsGrowlerOutletComponent {
    @HostBinding("class.sps-growler-area")
    @HostBinding("class.z-stratum-dialog")
    readonly _staticClassBindings = true;

    get growlers() {
        return this._growlerService.growlers;
    }

    constructor(
        changeDetector: ChangeDetectorRef,
        private _growlerService: SpsGrowlerService
    ) {
        _growlerService.change.subscribe(() => changeDetector.markForCheck());
    }

    onGrowlerClose(growler: GrowlerConfig) {
        this._growlerService.removeGrowler(growler);
        if (growler.onClose) {
            growler.onClose();
        }
    }
}
